import { pick } from 'lodash';
import { binToStr } from '@zapier/product-get-help/esm/utils';
const decodeErrorBundle = (base64Bundle) => {
    try {
        const binaryBundle = atob(base64Bundle);
        const jsonBundle = binToStr(binaryBundle);
        const errorBundle = JSON.parse(jsonBundle);
        const slimBundle = pick(errorBundle, 'id', 'title', 'code', 'status', 'step');
        return slimBundle;
    }
    catch (_) {
        return undefined;
    }
};
export default decodeErrorBundle;
